import { useRoutes } from "react-router-dom";
import { routes } from "modules";

export const Routes = () => useRoutes(routes);